// Feature flags. Read once at build time from .env (VUE_APP_* variables).
//
// POST_BID_ENABLED — the post-bid (project execution) system: Active /
// Completed Projects, Project Board, Deliverables, the Project tab in Bid
// Details (email records, contract documents, compensation claims, client
// contacts, client liaison mailbox), the Admin Panel's Compensation Claims and
// Email Records tabs, and marking bids as Won / Completed.
// Switched off for now: none of it shows, and its routes redirect away. The
// backend blocks the same features (bid_managment/src/oauth/feature_gate.py).
// To bring it back, set VUE_APP_POST_BID_ENABLED=true here AND
// POST_BID_ENABLED=true in the backend .env, then rebuild.
export const POST_BID_ENABLED = String(process.env.VUE_APP_POST_BID_ENABLED || '').toLowerCase() === 'true';

// Route names that exist only for post-bid.
export const POST_BID_ROUTES = new Set([
    'ActiveProjects',
    'CompletedProjects',
    'ProjectBoard',
    'Deliverables',
    'Analytics',
]);

// CHECKLIST_ENABLED — the Features Checklist: its card in the Bid Details
// Analysis tab and the standalone checklist page behind it.
// Switched off for now, the same way post-bid is: the card doesn't render and
// the route redirects away. The backend blocks its endpoints
// (bid_managment/src/oauth/feature_gate.py).
// To bring it back, set VUE_APP_CHECKLIST_ENABLED=true here AND
// CHECKLIST_ENABLED=true in the backend .env, then rebuild.
export const CHECKLIST_ENABLED = String(process.env.VUE_APP_CHECKLIST_ENABLED || '').toLowerCase() === 'true';

// Route names that exist only for the checklist.
export const CHECKLIST_ROUTES = new Set([
    'BidChecklist',
]);
